export const noop = () => undefined;
export const noopPromise = async (): Promise<any> => undefined;
export const noopObject = () => ({});
